import { Injectable, Injector } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs/Rx'
import { switchMap, tap } from 'rxjs/operators'
import { apiUrl as API_ENDPOINT, baseUrl as API_BASEURL, getPdfRedirectUrl } from '../../helper/common'
import { AuthHelper } from '@helpers/auth.helper'
import { Subject } from 'rxjs/Subject'
import { Router } from '@angular/router'
import { CookieService } from 'ngx-cookie-service'

@Injectable()
export class RequestServices {

    private emitLoading = new Subject<boolean>()
    private statusToken = true
    // Observable string streams
    loadingEmitted$ = this.emitLoading.asObservable()

    constructor(private http: HttpClient, private _injector: Injector, private cookieService: CookieService) {
    }

    private get router() { return this._injector.get(Router); }
    /**
     *
     */
    private getAuthToken(): Observable<string> {
        return new Observable<string>(subscriber => {
            const currentToken = AuthHelper.getToken()
            let device = AuthHelper.getUser().clientDeviceId
            if (!AuthHelper.checkTokenExpired() || typeof device !== 'undefined') {
                this.statusToken = true
                console.warn('set new timeout, renew token')
                const renewUrl = 'account/renew'
                return this.http.post(this.getFullPath(renewUrl), null, this.httpHeadersToken(currentToken)).subscribe(responseUser => {
                    AuthHelper.initAuth(responseUser)
                    subscriber.next(AuthHelper.getToken())
                }, error => {
                    AuthHelper.destroyLocalStorageInfo()
                    subscriber.error(error)
                })
            } else {
                this.statusToken = false
                subscriber.next(currentToken)
            }
        })
    }

    /**
     *
     * @param useCookie
     */
    private getHttpHeaders(useCookie = false): Observable<object> {
        return new Observable(subscriber => {
            this.getAuthToken().subscribe(token => {
                if (this.statusToken == false) {
                    this.logout()
                }
                let headers
                if (useCookie) {
                    headers = this.httpHeadersTokenCookie(token)
                } else {
                    headers = this.httpHeadersToken(token)
                }
                subscriber.next(headers)
            }, error => {
                subscriber.error(error)
            })

        })
    }

    /**
     *
     * @param token
     */
    httpHeadersToken(token) {
        const bearerToken = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ token ? JSON.parse(token) : '' }`,
            }),
        }
        return bearerToken
    }

    /**
     *
     * @param token
     */
    httpHeadersTokenCookie(token) {
        const cookieToken = {
            headers: new HttpHeaders({ Cookie: `token=${ JSON.parse(token) }` }),
        }
        return cookieToken
    }

    httpPostResource(requestPayload: any): Observable<object> {
        return this.httpPost('resource', requestPayload)
    }

    // /**
    //  * Send Post Request
    //  * @param targetUrl
    //  * @param requestPayload
    //  */
    httpPost(targetUrl, requestPayload: any): Observable<object> {
        console.log('httpPost', requestPayload)
        return this.getHttpHeaders().pipe(
            switchMap(headerOptions => this.doPost(targetUrl, requestPayload, headerOptions)),
            tap(responseData => console.log('responseData', responseData)),
        )
    }

    /**
     * Send Get Request
     * @param targetUrl
     * @param useCookie
     */
    httpGet(targetUrl, useCookie = false): Observable<any> {
        console.log('httpGet', targetUrl)
        return this.getHttpHeaders(useCookie).pipe(
            switchMap(headerOptions => this.doGet(targetUrl, headerOptions)),
        )
    }

    /**
     * Send Get Request
     * @param targetUrl
     * @param useCookie
     */
    httpGetBaseApi(targetUrl, useCookie = false): Observable<any> {
        console.log('httpGet', targetUrl)
        return this.getHttpHeaders(useCookie).pipe(
            switchMap(headerOptions => this.doGetBaseAPI(targetUrl, headerOptions)),
        )
    }

    /**
     *
     * @param targetUrl string
     * @param requestPayload object
     * @param headerOptions object
     */
    doPost(targetUrl, requestPayload, headerOptions): Observable<any> {
        return this.http.post<any>(
            this.getFullPath(targetUrl),
            requestPayload,
            headerOptions,
        )
    }

    /**
     *
     * @param targetUrl string
     * @param headerOptions object
     */
    doGet(targetUrl, headerOptions): Observable<any> {
        return this.http.get(this.getFullPath(targetUrl), headerOptions)
    }

    /**
     *
     * @param targetUrl string
     * @param headerOptions object
     */
    doGetBaseAPI(targetUrl, headerOptions): Observable<any> {
        return this.http.get(targetUrl, headerOptions)
    }

    setLoading(loading = false) {
        this.emitLoading.next(loading)
    }

    public postFile(file: File, path = 'image/create'): Observable<object> {
        const formData: FormData = new FormData()
        let fileName = file && file.name ? file.name : ''
        formData.append('file', file, fileName)

        return this.getAuthToken().pipe(
            switchMap(token => {
                if (this.statusToken == false) {
                    this.logout()
                }
                const headerOptions = {
                    headers: new HttpHeaders({ 'Authorization': `Bearer ${ JSON.parse(token) }` }),
                }
                return this.doPost(path, formData, headerOptions)
            }),
        )
    }

    public downloadFile(id, filename = null, useCookie = false, callback = null) {
        const targetUrl = getPdfRedirectUrl(id)
        return this.getHttpHeaders(useCookie).pipe(
            switchMap(headerOptions => this.doGetBaseAPI(targetUrl, headerOptions)),
        ).subscribe(success => {
            this.http.get(success['url'], { responseType: 'blob' as 'json' }).subscribe(
                (response: any) => {
                    const dataType = response.type
                    const binaryData = []
                    binaryData.push(response)
                    const downloadLink = document.createElement('a')
                    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }))
                    if (filename) {
                        downloadLink.setAttribute('download', filename)
                    }

                    if (typeof callback === 'function') {
                        callback()
                    }
                    // document.body.appendChild(downloadLink)
                    downloadLink.click()
                },
            )
        })
    }

    /**
     * Return pull path with checking endpoint url
     * @param path
     */
    private getFullPathBaseApi(path) {
        console.log(path)
        console.log(API_BASEURL)
        console.log(`${ API_BASEURL }${ path }`)
        if (path.startsWith('http')) {
            return path
        }
        return `${ API_BASEURL }${ path }`
    }

    /**
     * Return pull path with checking endpoint url
     * @param path
     */
    private getFullPath(path) {
        if (path.startsWith('http')) {
            return path
        }
        return `${ API_ENDPOINT }/${ path }`
    }

    private logout() {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('timeout')
        this.cookieService.delete('token')
        jQuery('body').attr('class', 'blue')
        localStorage.removeItem('urlLogo')
        localStorage.removeItem('classThemeBody')
        return this.router.navigateByUrl('/app/login')
    }

}



// WEBPACK FOOTER //
// ./src/app/services/request.services.ts